<template>
  <section
    class="app-main"
    :class="{ 'app-main--watermark': isExtranet }"
    :style="isExtranet ? { '--watermark-logo': 'url(/images/new-logo-rond-seul-transp.png)' } : {}"
  >
    <router-view v-slot="{ Component }">
      <transition
        name="fade-transform"
        mode="out-in"
      >
        <!-- La clé vaut l'URL complète : changer de paramètre remonte donc
             l'écran. Un écran qui pilote lui-même son contenu (la Documentation,
             dont le slug ne change que la fiche affichée) déclare `meta.viewKey`
             pour garder son instance et éviter un remontage complet à chaque
             clic.

             `meta.noCache` sort l'écran du cache : son instance est detruite en
             partant, et son `created()` rejoue au retour. Sans cela, un tableau
             quitte puis rouvert reaffichait ses anciennes lignes, et il fallait
             recharger la page pour voir la donnee. La quasi-totalite des routes
             le declarent — personne ne le lisait.

             Les commentaires restent hors de <keep-alive>, qui n'accepte qu'un
             seul enfant. -->
        <keep-alive v-if="!$route.meta.noCache">
          <component
            :is="Component"
            :key="$route.meta.viewKey ?? $route.fullPath"
          />
        </keep-alive>
        <component
          :is="Component"
          v-else
          :key="$route.meta.viewKey ?? $route.fullPath"
        />
      </transition>
    </router-view>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    isExtranet() {
      // Côté calculé par le serveur (UserResource.scope) : chercher le rôle
      // « extranet client » dans la liste servait l'interface interne à tout
      // client portant un autre profil extranet.
      return this.$store.getters['user/isExtranet'] || this.$route.path.startsWith('/extranet');
    }
  }
};
</script>

<style scoped>
.app-main {
  margin-top: 50px;
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

/* Transitions pour les changements de route */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.2s ease;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-10px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(10px);
}

/* ===== Logo filigrane extranet ===== */
.app-main--watermark::before {
  content: '';
  position: fixed;
  top: 200px; /* sous la navbar + menu onglets + section header */
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--watermark-logo);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: auto 80%;
  opacity: 0.04;
  pointer-events: none;
  z-index: 0;
}
</style>

<style>
/* ===== Harmonisation globale extranet ===== */
/* Espacement du contenu sous le SectionHeader */
.app-main--watermark .app-container > .el-form,
.app-main--watermark .app-container > .el-input,
.app-main--watermark .app-container > div:not(.page-nav-menu):not([class*="section-header"]):not([class*="page-header"]) {
  position: relative;
  z-index: 1;
}

/* Décoller le contenu du SectionHeader */
.app-main--watermark .admin-table-wrapper,
.app-main--watermark .el-table,
.app-main--watermark .pagination-container {
  position: relative;
  z-index: 1;
}

/* Premier élément de contenu après le SectionHeader */
.app-main--watermark .section-header + *,
.app-main--watermark .page-nav-menu + .section-header + * {
  margin-top: 16px !important;
}

/* Masquer la pagination "30/page" inutile en extranet */
.app-main--watermark .pagination-container .el-pagination__sizes {
  display: none;
}
</style>
